module.exports = __webpack_public_path__ + "img/s8Bg7.404d668a.jpg";